import {memo, useCallback} from 'react'
import {RenderComponent} from 'src/biz/common/renderComponent'
import {isEmpty, transferSource} from 'src/biz/utils'
import {Form, Modal as UIModal} from 'src/ui'
import type {ModalProps} from 'src/ui'
import type {baseBtnType, baseComponentType, btnBaseListType, schemaApiType} from '../types'
import styles from './index.module.scss'

export type ModalPropsType = ModalProps & {
  apiList?: schemaApiType
  schema: {
    componentList: baseComponentType[] | string // 弹窗表单项
    btnList: btnBaseListType[] | string // 弹窗按钮操作项
  }
  layout?: 'horizontal' | 'vertical' | 'inline' //表单布局
  handleOk?: ((form?: any) => void) | any // 确认关闭回调
  handleCancel?: ((form?: any) => void) | any // 取消关闭回调
  form?: any // form 实例
  isModalOpen: boolean // 弹窗打开关闭控制
  modalTitle: string // 弹窗title
  getContainer?: HTMLElement // 挂载节点
  footer?: React.ReactNode | ((params: any) => React.ReactNode)
  okText?: string // 确认按钮文字
  cancelText?: string // 	取消按钮文字
  classNames?: Record<string, any>
  style?: React.CSSProperties
}

const FormModal: React.FC<ModalPropsType> = props => {
  const [form] = Form.useForm()
  const FormInstance = props.form || form
  const {
    schema,
    isModalOpen,
    handleOk,
    handleCancel,
    modalTitle = 'Modal Title',
    getContainer,
    footer,
    classNames,
    style,
    ...rest
  } = props
  const {componentList, btnList} = schema
  const newComponentList = transferSource<baseComponentType[]>(componentList)
  const newBtnList = transferSource<btnBaseListType[]>(btnList)
  const modalFormBtn = useCallback(
    (type: baseBtnType, action: (type: baseBtnType, form: any) => any) => {
      action && action(type, FormInstance)
    },
    [FormInstance],
  )
  return (
    <UIModal
      getContainer={getContainer || document.body}
      footer={footer}
      title={modalTitle}
      open={isModalOpen}
      onOk={() => handleOk && handleOk(FormInstance)}
      onCancel={() => handleCancel && handleCancel(FormInstance)}
      classNames={classNames}
      style={style}
      {...rest}
    >
      <Form form={FormInstance} layout={props.layout || 'horizontal'}>
        {newComponentList.map((comp: baseComponentType, index: number) => {
          return (
            <Form.Item name={comp.name} key={`${index}_form_modal`} label={comp.label}>
              <RenderComponent {...comp} />
            </Form.Item>
          )
        })}
        {!isEmpty(newBtnList) && (
          <div className={styles.btnContainer}>
            {newBtnList.map((comp: btnBaseListType, index: number) => {
              const {btnFormAction, ...rest}: any = comp
              return (
                <Form.Item key={`${index}_btn}`}>
                  <RenderComponent {...rest} onClick={() => modalFormBtn(comp.type, btnFormAction)} />
                </Form.Item>
              )
            })}
          </div>
        )}
      </Form>
    </UIModal>
  )
}
// export const Modal = memo(FormModal)
export default memo(FormModal)
